<template>
    <div class="m-auto px-8 md:px-20">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-5 text-2xl font-bold">
                {{id? 'Dettaglio': 'Nuova'}} attività timesheet
            </div>

            <div v-show="response_message.length" :class="[esito ? 'bg-next-bri' : 'bg-next-orange']"
                 class="text-white p-3 mb-3 flex justify-between items-center">
                {{ response_message }}
                <i class="icon-x cursor-pointer" @click="response_message = ''"></i>
            </div>

            <div class="pt-5 flex flex-col">
                <Field field_name="Voce timesheet" :errors="getErrors('voce_spesa_id')">
                    <VueMultiselect
                        v-model="voceTimesheetAutocomplete.selection"
                        :options="voceTimesheetAutocomplete.options"
                        placeholder="Voce di spesa"
                        class="next-vue-multiselect-single"
                        track-by="id"
                        label="descrizione"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="voceTimesheetAutocomplete.search"
                    >
                    </VueMultiselect>
                </Field>
            </div>

            <div class="pt-5 flex flex-col">
                <Field field_name="Business unit" :errors="getErrors('business_unit')">
                    <VueMultiselect
                        v-model="buAutocomplete.selection"
                        :options="buAutocomplete.options"
                        placeholder="Business unit"
                        class="next-vue-multiselect-single"
                        track-by="id"
                        label="nome"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="buAutocomplete.search"
                    >
                    </VueMultiselect>
                </Field>
            </div>

            <div class="pt-5 flex flex-col">
                <Field field_name="Voce di spesa" :errors="getErrors('voce_spesa_id')">
                    <VueMultiselect
                        v-model="vocespesaAutocomplete.selection"
                        :options="vocespesaAutocomplete.options"
                        placeholder="Voce di spesa"
                        class="next-vue-multiselect-single"
                        track-by="id"
                        label="descrizione"
                        selectLabel=""
                        deselectLabel=""
                        selectedLabel=""
                        :internal-search="false"
                        @search-change="vocespesaAutocomplete.search"
                    >
                    </VueMultiselect>
                </Field>
            </div>

            <div class="pt-5 flex flex-col">
                <Checkbox
                    checkClass="h-3 w-3"
                    :checked="visible_attivita_generale"
                    @change="visible_attivita_generale = !visible_attivita_generale"
                >
                    Visibile come attivita timesheet generale
                </Checkbox>
            </div>
            <div class="pt-5 flex flex-col">
                <Checkbox
                    checkClass="h-3 w-3"
                    :checked="visible_attivita_sottoprogetto"
                    @change="visible_attivita_sottoprogetto = !visible_attivita_sottoprogetto"
                >
                    Visibile come attivita timesheet dei sottoprogetti
                </Checkbox>
            </div>

            <div class="flex pt-3 justify-between">
                <div>
                    <NextButton v-show="id" class="px-3 py-2" @click="cancella">Cancella</NextButton>
                </div>
                <NextButton class="px-3 py-2" @click="save">Salva</NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import NextTable from "@/components/NextTable.vue";
import InfiniteLoading from "v3-infinite-loading";
import Loading from "@/components/Loading.vue";
import Field from "@/components/Field.vue";
import NextButton from "@/components/NextButton.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Autocomplete from "@/setup/Autocomplete";
import {mapGetters} from 'vuex';
import voceSpesaManager from "@/api/VoceSpesaManager";
import aliquotaManager from "@/api/AliquotaManager";
import businessUnitsManager from "@/api/BusinessUnits";
import voceSpesaBusinessUnitIvaManager from "@/api/VoceSpesaBusinessUnitIvaManager";
import timesheetManager from "@/api/Timesheet";
import attivitaTimesheetManager from "@/api/SottoprogettoAttivitaTimesheet";
import businessUnitAttivitaTimesheetVociSpesaManager from "@/api/BusinessUnitAttivitaTimesheetVociSpesaManager";
import Checkbox from "@/components/Checkbox.vue";

@Options({
    name: 'DettaglioAttivitaTimesheet',
    components: {
        Checkbox,
        MultiselectOption, NextButton,
        Loading,
        Field,
        NextTable,
        InfiniteLoading,

    },
    props: {
        id: {
            type: [String, Number],
            required: false
        },
    },
    computed: {
        ...mapGetters('buFieldModule', [
            'allField',
            'cellsDescriptor',
            'isCellAcquisto',
            'isCellVendita',
            'isCellRe',
            'isCellNe',
        ]),
    }
})
export default class DettaglioAttivitaTimesheet extends Vue {
    voceTimesheetAutocomplete: any = setup(() => Autocomplete(attivitaTimesheetManager))
    vocespesaAutocomplete: any = setup(() => Autocomplete(voceSpesaManager))
    buAutocomplete: any = setup(() => Autocomplete(businessUnitsManager, false))

    id!: number
    visible_attivita_generale = false
    visible_attivita_sottoprogetto = false

    esito = false
    response_message = ''
    errors = {}

    getErrors(field: string) {
        return (this.errors as any)[field]
    }


    created(){
        if(this.id) {
            businessUnitAttivitaTimesheetVociSpesaManager.retrieve(this.id).then((res) => {
                this.voceTimesheetAutocomplete.retrieve(res.data.attivita_timesheet_id)
                this.vocespesaAutocomplete.retrieve(res.data.voce_spesa_id)
                this.buAutocomplete.retrieve(res.data.business_unit_id)
                this.visible_attivita_generale = res.data.attivita_generale
                this.visible_attivita_sottoprogetto = res.data.attivita_sottoprogetto
            })
        }
        this.voceTimesheetAutocomplete.search('', 0)
        this.vocespesaAutocomplete.search('', 0)
        this.buAutocomplete.search('', 0)
    }

    mounted(){
        this.esito = false
        this.response_message = ''
    }

    save(){
        if(this.id){
            businessUnitAttivitaTimesheetVociSpesaManager.update(this.id, {
                voce_spesa: this.vocespesaAutocomplete.selection?.id,
                business_unit: this.buAutocomplete.selection?.id,
                attivita_timesheet: this.voceTimesheetAutocomplete.selection?.id,
                attivita_generale: this.visible_attivita_generale,
                attivita_sottoprogetto : this.visible_attivita_sottoprogetto,
            }).then(()=>{
                this.esito = true
                this.response_message = 'Salvataggio avvenuto corretamente'
            }).catch((res)=>{
                this.esito = false
                this.response_message = 'Salvataggio fallito'
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            })
        } else {
            businessUnitAttivitaTimesheetVociSpesaManager.create({
                voce_spesa: this.vocespesaAutocomplete.selection?.id,
                business_unit: this.buAutocomplete.selection?.id,
                attivita_timesheet: this.voceTimesheetAutocomplete.selection?.id,
                attivita_generale: this.visible_attivita_generale,
                attivita_sottoprogetto : this.visible_attivita_sottoprogetto,
            }).then((res:any)=>{
                //@ts-ignore
                this.$router.replace({name:'DettaglioAttivitaTimesheet', params:{id:res.data.id}})
            }).catch((res)=>{
                this.esito = false
                this.response_message = 'Salvataggio fallito'
                if (res.response.status == 422) {
                    this.errors = res.response.data.errors
                }
            })
        }

    }

    async cancella(){
        businessUnitAttivitaTimesheetVociSpesaManager.delete(this.id).finally(()=>{
            //@ts-ignore
            this.$router.replace({name:'AttivitaTimesheet'})
        })
    }

}

</script>


<style lang="scss">

</style>
